$("._toggle-menu").click(function () {
    $(".header").toggleClass("_open")
    $("body").toggleClass("fixed-body")
})

$(".menu-item-has-children>a").click(function () {
    $(this).parents(".menu-item-has-children").toggleClass("_open")
    $(this).siblings(".sub-menu").slideToggle()
})

